import {helpApiBase} from '..';
import {
  MyInquiryDetailResponse,
  MyInquiryListResponse,
  IsEvaluatedInquiryResponse,
} from './type';

export const getMyInquiryList = ({
  page,
}: {
  page: number;
}): Promise<MyInquiryListResponse> => {
  return helpApiBase({
    type: 'exMailMyBoard',
    command: 'QnaList',
    domainId: 'sooplive',
    pageNo: page,
    rowsPerPage: 10,
  });
};

export const getMyInquiryDetail = ({
  inquiryId,
}: {
  inquiryId: string;
}): Promise<MyInquiryDetailResponse> => {
  return helpApiBase({
    type: 'exMailMyAnswer',
    command: 'QnaContents',
    domainId: 'sooplive',
    ticketId: inquiryId,
  });
};

// 만족도 평가 여부
export const getIsEvaluatedInquiry = ({
  inquiryId,
}: {
  inquiryId: string;
}): Promise<IsEvaluatedInquiryResponse> => {
  return helpApiBase({
    command: 'CommonSurveyExist',
    domainId: 'sooplive',
    targetId: inquiryId,
    serviceType: 'SVQNA',
    surveyType: 'CUSAF',
  });
};

export const evaluateInquiry = ({
  isMember,
  inquiryId,
  surveyForm,
}: {
  isMember: 'Y' | 'N';
  inquiryId: string;
  surveyForm: {speed: number; feedback: number};
}) => {
  return helpApiBase({
    command: 'setSurveyAnswer',
    domainId: 'sooplive',
    targetId: inquiryId,
    serviceType: 'SVQNA',
    surveyType: 'CUSAF',
    option01: surveyForm.speed,
    feedback: surveyForm.feedback,
    isMember,
  });
};

export const getInquiryInfo = ({inquiryId}: {inquiryId: string}) => {
  return helpApiBase({
    command: 'getTicketInfo',
    domainId: 'sooplive',
    ticketId: inquiryId,
  });
};
